export default __webpack_public_path__ + "static/media/img_folio.d121b72a.png";